import { KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";
/**
 * Sensors for a drag-to-reorder list: pointer for mouse/touch, keyboard for
 * accessible reordering. Shared by every @dnd-kit sortable in the package so
 * drag activation behaves identically everywhere (decision-table rules, step
 * inputs, …).
 */ export function useReorderSensors() {
    return useSensors(useSensor(PointerSensor), useSensor(KeyboardSensor, {
        coordinateGetter: sortableKeyboardCoordinates
    }));
}

//# sourceMappingURL=useReorderSensors.js.map